
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$data-provider.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$data-provider.js';
export default __default__;
